import { useMutation } from '@tanstack/react-query';

import { RevenuePlanApi } from '../revenuePlan.api';

export const useGetCalculationsOnProductUpdateRevenue = () => {
  return useMutation({
    mutationFn: RevenuePlanApi.getCalculationsOnProductUpdate,
  });
};
